import axios from 'axios';
import { Auth } from 'aws-amplify';
import { GET_ALL_CLUSTERS } from '../../types';
import { NEW_GET_ALL_CLUSTERS } from '../../API';

export const getAllClusters = () => async (dispatch) => {
  const user = await Auth.currentAuthenticatedUser();
  const token = user.signInUserSession.idToken.jwtToken;
  const email = user.attributes.email;
  const userId = user?.username;

  try {
    const params = {
      email,
      userId,
    };

    const res = await axios.get(NEW_GET_ALL_CLUSTERS, {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer '.concat(token),
      },
      params,
    });
    if (res && res.data && res.data.success === true) {
      dispatch({
        type: GET_ALL_CLUSTERS,
        payload: res.data.clusters,
      });
    } else {
      dispatch({
        type: GET_ALL_CLUSTERS,
        payload: [],
      });
    }
  } catch (err) {
    dispatch({
      type: GET_ALL_CLUSTERS,
      payload: [],
    });
    if (err.response) {
      // The client was given an error response (5xx, 4xx)
      console.log(err.response.data);
      console.log(err.response.status);
      console.log(err.response.headers);
    } else if (err.request) {
      console.log(err.request);
      // The client never received a response, and the request was never left
    } else {
      console.log('Error', err.message);
    }
  }
};
